import {useIntl} from "react-intl";

export function useTranslations() {
  const intl = useIntl()
  return (id: string) => intl.formatMessage({id});
}